import Header from 'components/navigation/Header';
import { ISOToMMDDYYYY } from 'helpers/generalHelpers';
import { getPrescriptionList, lookupMed, takenSinceFilled } from 'helpers/medicationHelpers';
import React, { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

export default function PrescriptionList() {
	const params = useParams();
	const medId = params.id;
	const navigate = useNavigate();

	const preList = getPrescriptionList(medId);
	console.log('PrescriptionList', medId, preList);
	const med = useMemo(() => lookupMed(medId), []);


	return (
		<div>
			<Header title='Prescriptions' help='Prescriptionlist' />
			{medId &&
				<div className='mcard-header'>
					<div className='p-2 font-bold text-2xl text-left'>
						{med.name}
					</div>
				</div>
			}
			{/* <div className='mcard-header'>Medication History</div> */}
			<div id='scroll_area' className='lcard mb-1'>
				{preList.map((p, ix) => {
					const taken = takenSinceFilled(p);
					return (
						<div className='mcard border-2 border-gray-200 mb-1' key={ix}>
							<div className='histItem'>
								<div>
									Filled: {ISOToMMDDYYYY(p.dateFilled)}
									<br />
									Quantity: {p.quantityFilled}
									<br />
									Pharmacy: {p.pharmacy}
									<br />
									Taken since filled: {taken}
								</div>
								<button
									className='histItemBtn bg-red-700'
								>
									Delete
								</button>
							</div>
						</div>
					)
				})
				}
			</div>
			<div style={{ height: '60px' }} />
		</div>
	)
}

